let language = {
    PRODUCT_MANAGER_SUBTOTAL:'小计',
    PRODUCT_MANAGER_TOTAL:'总计',
    PRODUCT_MANAGER_ORDERS:'订单',
    PRODUCT_MANAGER_UNIT_PRICE:'单价',
    PRODUCT_MANAGER_QTY:'数量',
    PRODUCT_MANAGER_TOTAL_PRICE:'总价',
    PRODUCT_MANAGER_STORE:'商店',
    PRODUCT_MANAGER_ERROR_104000001:'当前用户没有权限操作此资源',
};

export { language }